import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import images from '../../data/images.json';
import './News.css';

const News: React.FC = () => {
  const { t } = useTranslation();

  const newsItems = [
    {
      image: images.blog.post1,
      title: t('news.items.item1.title'),
      date: t('news.items.item1.date'),
      excerpt: t('news.items.item1.excerpt')
    },
    {
      image: images.blog.post2,
      title: t('news.items.item2.title'),
      date: t('news.items.item2.date'),
      excerpt: t('news.items.item2.excerpt')
    },
    {
      image: images.blog.post3,
      title: t('news.items.item3.title'),
      date: t('news.items.item3.date'),
      excerpt: t('news.items.item3.excerpt')
    }
  ];

  return (
    <div className="news-page">
      <div className="news-hero">
        <div className="container">
          <h1 className="page-title">{t('news.title')}</h1>
        </div>
      </div>

      <section className="news-section">
        <div className="container">
          <div className="news-grid">
            {newsItems.map((item, index) => (
              <article key={index} className="news-card">
                <div className="news-image">
                  <img
                    src={item.image}
                    alt={item.title}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = 'https://via.placeholder.com/400x300/f4c430/333333?text=News';
                    }}
                  />
                </div>
                <div className="news-content">
                  <div className="news-date">{item.date}</div>
                  <h3>{item.title}</h3>
                  <p>{item.excerpt}</p>
                  <Link to="/" className="news-read-more">
                    {t('news.readMore')} →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default News;









